module.exports = __webpack_public_path__ + "static/media/logo-coloured.cf879160.svg";